import { render } from "./RichSystem.vue?vue&type=template&id=290a3ef0"
import script from "./RichSystem.vue?vue&type=script&lang=js"
export * from "./RichSystem.vue?vue&type=script&lang=js"

import "./RichSystem.vue?vue&type=style&index=0&id=290a3ef0&lang=sass"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__